/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { isValidTimestamp } from '@customerio/fly-components/utils/validators/timestamp';
import EnvironmentService from 'cio/services/environment';
import { IdentifierKey, isAttributeEnabledIdentifier } from 'cio/utils/identifiers';
import { isJSONAttribute, toJSONAttribute } from 'cio/utils/attributes';

interface AttributeListItemArgs {
  attribute: Record<string, string>;
  listItemClassNames?: string;
  itemValueClassNames?: string;
  ignoreIdentifiers?: boolean;
  isObject?: boolean;
}

export default class AttributeListItem extends Component<AttributeListItemArgs> {
  @service environment!: EnvironmentService;

  @tracked jsonExpanded = false;

  get key() {
    return Object.keys(this.args.attribute)[0];
  }

  get val() {
    return Object.values(this.args.attribute)[0];
  }

  get isAttributeAutoGenerated() {
    if (
      this.key === IdentifierKey.CioId &&
      !this.environment.current.allEnabledIdentifiers.includes(IdentifierKey.CioId)
    ) {
      return true;
    }

    return this.key === 'id' && this.environment.current.isEmailIdentified;
  }

  get isJSON() {
    return isJSONAttribute(this.val);
  }

  get isTimestamp() {
    return !isAttributeEnabledIdentifier(this.key, this.environment.current.identifiers) && isValidTimestamp(this.val);
  }

  get json() {
    if (!this.isJSON) {
      return null;
    }

    try {
      return toJSONAttribute(this.val);
    } catch (e) {
      return null;
    }
  }

  get jsonStr() {
    let data = this.json;
    if (data === null) {
      return this.val;
    }
    return JSON.stringify(data);
  }

  @action
  toggleJsonPreview() {
    this.jsonExpanded = !this.jsonExpanded;
  }
}
